import { createAsyncAction, createAction } from 'typesafe-actions';
import { PhotosResponse, Photo } from './types';
import { Token } from '../users/types'
import { authFetch, unauthFetch } from '../../utils';

export const updateApiError = createAction('photos/UPDATE_API_ERROR', resolve =>
  (apiError: string) => resolve(apiError)
);

export const getPhotosByParkCodeActions = createAsyncAction(
  'photos/FETCH_BY_PARK_CODE_REQUEST',
  'photos/FETCH_BY_PARK_CODE_SUCCESS',
  'photos/FETCH_BY_PARK_CODE_FAILURE'
)<void, PhotosResponse, Error>();

export const getPhotosByParkCode = (parkCode: string, nextKey?: string) => {
  return (dispatch: any) => {
    return dispatch(async (dispatch: any) => {
      dispatch(getPhotosByParkCodeActions.request());
      const key = nextKey ? `?nextkey=${nextKey}` : '';
      const result: any = await unauthFetch(`photos/parks/${parkCode}${key}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
      });
      if (result.status === 404) {
        dispatch(getPhotosByParkCodeActions.failure(new Error('Not found.')));
        return;
      }
      const res = await result.json();
      dispatch(getPhotosByParkCodeActions.success({ ...res, hasNextKey: !!nextKey  }));
    });
  };
};

export const getUserParkPhotosCodeActions = createAsyncAction(
  'photos/FETCH_BY_USER_PARK_CODE_REQUEST',
  'photos/FETCH_BY_USER_PARK_CODE_SUCCESS',
  'photos/FETCH_BY_USER_PARK_CODE_FAILURE'
)<void, PhotosResponse, Error>();

export const getUserParkPhotosByCode = (tokens: Token, parkCode: string, nextKey?: string) => {
  return (dispatch: any) => {
    return dispatch(async (dispatch: any) => {
      dispatch(getUserParkPhotosCodeActions.request());
      const key = nextKey ? `?nextkey=${nextKey}` : '';
      const result: any = await authFetch(tokens, {
          url: `photos/parks/${parkCode}${key}`,
        param: {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json; charset=UTF-8',
          },
        },
      }, dispatch);
      if (result.status === 404) {
        dispatch(getUserParkPhotosCodeActions.failure(new Error('Not found.')));
        return;
      }
      const res = await result.json();
      dispatch(getUserParkPhotosCodeActions.success({ ...res, hasNextKey: !!nextKey  }));
    });
  };
};

export const getPhotoCommentsActions = createAsyncAction(
  'photos/FETCH_PHOTO_COMMENTS_REQUEST',
  'photos/FETCH_PHOTO_COMMENTS_SUCCESS',
  'photos/FETCH_PHOTO_COMMENTS_FAILURE'
)<void, PhotosResponse, Error>();

export const getPhotoComments = (photoId: string, nextKey?: string) => {
  return (dispatch: any) => {
    return dispatch(async (dispatch: any) => {
      dispatch(getPhotoCommentsActions.request());
      const key = nextKey ? `?nextkey=${nextKey}` : '';
      const result: any = await unauthFetch(`photos/${photoId}/comments${key}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
      });
      if (result.status === 404) {
        dispatch(getPhotoCommentsActions.failure(new Error('Not found.')));
        return;
      }
      const res = await result.json();
      dispatch(getPhotoCommentsActions.success({ ...res, hasNextKey: !!nextKey }));
    });
  };
};

export const getPhotoByIdAction = createAsyncAction(
  'photos/FETCH_PHOTO_BY_ID_REQUEST',
  'photos/FETCH_PHOTO_BY_ID_SUCCESS',
  'photos/FETCH_PHOTO_BY_ID_FAILURE'
)<void, PhotosResponse, Error>();

export const getPhotoById = (photoId: string, tokens?: Token) => {
  return (dispatch: any) => {
    return dispatch(async (dispatch: any) => {
      dispatch(getPhotoByIdAction.request());
      let result: any;
      result = await unauthFetch(`photos/${photoId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
      });
      // if (!tokens) {
      //   result = await unauthFetch(`photos/${photoId}`, {
      //     method: 'GET',
      //     headers: {
      //       'Content-Type': 'application/json; charset=UTF-8',
      //     },
      //   });
      // } else {
      //   result = await authFetch(tokens, {
      //     url: `photos/${photoId}`,
      //     param: {
      //       method: 'GET',
      //       headers: {
      //         'Content-Type': 'application/json; charset=UTF-8',
      //       },
      //     },
      //   });
      // }
      if (result.status === 404) {
        dispatch(getPhotoByIdAction.failure(new Error('Not found.')));
        return;
      }
      const res = await result.json();
      dispatch(getPhotoByIdAction.success({ ...res }));
    });
  };
};

export const addPhotoAction = createAsyncAction(
  'photos/ADD_PHOTO_REQUEST',
  'photos/ADD_PHOTO_SUCCESS',
  'photos/ADD_PHOTO_FAILURE'
)<void, Photo, Error>();

export const addPhoto = (tokens: Token, parkCode: string, img: string, caption: string) => {
  return (dispatch: any) => {
    return dispatch(async (dispatch: any) => {
      dispatch(addPhotoAction.request());
      
      const result: any = await authFetch(tokens, {
        url: `photos/parks/${parkCode}/signedurl`,
        param: {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json; charset=UTF-8',
          },
          body: JSON.stringify({
            park_code: parkCode,
            caption,
          }),
        },
      }, dispatch);
      if (result.error) {
        dispatch(addPhotoAction.failure(new Error(result.error)));
        return;
      }
      const res = await result.json();
      const { signedUrl } = res;
      const uploadResult = await fetch(signedUrl, {
        method: 'PUT',
          headers: {
            'Content-Type': 'image/jpg'
          },
          body: await fetch(img).then(r => r.blob()),
      });
      // failed delete it
      console.log(uploadResult, uploadResult.status)
      if (uploadResult && uploadResult.status !== 200) {
        dispatch(addPhotoAction.failure(new Error(res.error && (res.error.description || res.error.message))));
        return;
      }
      getPhotosByParkCode(parkCode);
      dispatch(addPhotoAction.success(res));
    });
  };
};

export const likePhotoAction = createAsyncAction(
  'photos/LIKE_PHOTO_REQUEST',
  'photos/LIKE_PHOTO_SUCCESS',
  'photos/LIKE_PHOTO_FAILURE'
)<void, Photo, Error>();

export const likePhoto = (tokens: Token, photoId: string) => {
  return (dispatch: any) => {
    return dispatch(async (dispatch: any) => {
      dispatch(likePhotoAction.request());
      
      const result: any = await authFetch(tokens, {
        url: `photos/${photoId}/like`,
        param: {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json; charset=UTF-8',
          },
        },
      }, dispatch);
      if (result.error) {
        dispatch(likePhotoAction.failure(new Error(result.error)));
        return;
      }
      const res = await result.json();
      dispatch(likePhotoAction.success(res));
    });
  };
};

export const unlikePhotoAction = createAsyncAction(
  'photos/UNLIKE_PHOTO_REQUEST',
  'photos/UNLIKE_PHOTO_SUCCESS',
  'photos/UNLIKE_PHOTO_FAILURE'
)<void, Photo, Error>();

export const unlikePhoto = (tokens: Token, photoId: string) => {
  return (dispatch: any) => {
    return dispatch(async (dispatch: any) => {
      dispatch(unlikePhotoAction.request());
      
      const result: any = await authFetch(tokens, {
        url: `photos/${photoId}/like`,
        param: {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json; charset=UTF-8',
          },
        },
      }, dispatch);
      if (result.error) {
        dispatch(unlikePhotoAction.failure(new Error(result.error)));
        return;
      }
      const res = await result.json();
      dispatch(unlikePhotoAction.success(res));
    });
  };
};

export const commentPhotoAction = createAsyncAction(
  'photos/COMMENT_PHOTO_REQUEST',
  'photos/COMMENT_PHOTO_SUCCESS',
  'photos/COMMENT_PHOTO_FAILURE'
)<void, Photo, Error>();

export const commentPhoto = (tokens: Token, photoId: string, comment: string, parkCode: string) => {
  return (dispatch: any) => {
    return dispatch(async (dispatch: any) => {
      dispatch(commentPhotoAction.request());
      
      const result: any = await authFetch(tokens, {
        url: `photos/${photoId}/comments`,
        param: {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json; charset=UTF-8',
          },
          body: JSON.stringify({
            comment,
            photoId,
            park_code: parkCode,
          }),
        },
      }, dispatch);
      if (result.error) {
        dispatch(commentPhotoAction.failure(new Error(result.error)));
        return;
      }
      const res = await result.json();
      dispatch(commentPhotoAction.success(res));
    });
  };
};
